import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { UserPlus, Sparkles } from "lucide-react";

interface GuestUpgradePromptProps {
  isOpen: boolean;
  onClose: () => void;
  feature?: string;
}

const GuestUpgradePrompt = ({ isOpen, onClose, feature }: GuestUpgradePromptProps) => {
  const navigate = useNavigate();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[110] flex items-center justify-center bg-black/70 backdrop-blur-sm p-5"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-sm rounded-3xl p-6 text-center bg-card border border-primary/20 shadow-2xl"
          >
            <div className="w-16 h-16 rounded-full gradient-premium mx-auto mb-4 flex items-center justify-center shadow-xl">
              <Sparkles className="w-7 h-7 text-primary-foreground" />
            </div>
            <h3 className="text-xl font-display font-bold text-foreground mb-2">
              Create an account
            </h3>
            <p className="text-sm text-muted-foreground mb-5">
              {feature
                ? `Create an account to ${feature} and save your progress.`
                : "Create an account to unlock this feature and save your progress."}
            </p>
            <motion.button
              whileTap={{ scale: 0.97 }}
              onClick={() => {
                onClose();
                navigate("/upgrade");
              }}
              className="w-full py-3.5 rounded-2xl gradient-premium text-primary-foreground font-display font-bold shadow-lg flex items-center justify-center gap-2"
            >
              <UserPlus className="w-4 h-4" />
              Create Account
            </motion.button>
            <button onClick={onClose} className="mt-3 text-sm text-muted-foreground">
              Maybe later
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GuestUpgradePrompt;
